import { Row } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';

import PencilSquareIcon from 'assets/images/icons/pencil-square.svg?react';
import Tooltip from 'components/tooltip/Tooltip';
import { EditLinkStyled } from 'pages/automations/systemTemplates/SystemTemplatesTab.styles';
import { SystemTemplateRow } from 'pages/automations/systemTemplates/SystemTemplatesTab.types';

const ActionsCell = ({ row }: { row: Row<SystemTemplateRow> }) => {
  const { t } = useTranslation();
  const { key, readOnly } = row.original;

  if (readOnly) {
    return null;
  }

  return (
    <div>
      <Tooltip id="row-edit-template-button" text={t('common.edit')}>
        <EditLinkStyled data-testid="row-edit-template-button" to={`./${key}`}>
          <PencilSquareIcon aria-label={t('common.edit')} />
        </EditLinkStyled>
      </Tooltip>
    </div>
  );
};

export default ActionsCell;
